import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Button, DescriptionList } from '../../../../../ui';
import TeacherStatusBadge from '../ui-pending/TeacherStatusBadge';
import { ConfigContext } from '../../../../../Api/global/ApiContext';
import { deleteAe } from '../../../../../Api/apiUtils';
import { toast } from 'react-toastify';
import { MixpanelEvents, trackEvent } from '../../../../../utils/mixpanelTracking';

interface EventModalProps {
  isOpen: boolean;
  toggle: () => void;
  eventDetails: {
    classId: string;
    teacherName: string;
    classBookingStatus: any;
    classStatus: string;
    startTime: string;
    endTime: string;
    slotDate: string;
    studentUserId: string;
    courseName: any;
    studentName: any;
    studentEmail: any;
    studentContact: any;
    slotStatus: any;
    maxNumberOfSlots: any;
    slotsBooked: any;
    studentsParticipated?: any;
    studentJoinTime?: any;
    teacherJointime?: any;
    isInternationalSlot?: any;
    sessionNumber?: any;
    airlineBookingSlotId?: any;
    airlineTeacherSlotId: any;
  } | null; 
  fetchCalendar: (fromDate: string, toDate: string) => void;
  fromDate: string;
  toDate: string; 
  selectedCategory: string;
  teacherId?: string | number;
}

const EventModal: React.FC<EventModalProps> = ({ isOpen, toggle, eventDetails,  fetchCalendar, fromDate, toDate, teacherId }) => {
  const config = useContext(ConfigContext);
  const [isLoading, setIsLoading] = useState(false);
  console.log("event", eventDetails)
  const handleDelete = async () => {
    
    if (!eventDetails) return; 

    setIsLoading(true);
    try {
const airlineTeacherSlotId = eventDetails.airlineTeacherSlotId;
        await deleteAe(airlineTeacherSlotId);
        toast.success("Free slot deleted successfully.");
        trackEvent(MixpanelEvents.AE_CALENDAR_FREE_SLOT_DELETED, {
          teacherId: teacherId != null ? String(teacherId) : undefined,
          airlineTeacherSlotId: String(airlineTeacherSlotId ?? ""),
          slotDate: eventDetails.slotDate,
        });
        fetchCalendar(fromDate, toDate); 
        toggle();
    } catch (error) {
        console.error('Error deleting event:', error);
        trackEvent(MixpanelEvents.AE_CALENDAR_FREE_SLOT_DELETE_FAILED, {
          teacherId: teacherId != null ? String(teacherId) : undefined,
        });
        toast.error("Failed to delete free slot.");
    } finally {
        setIsLoading(false);
    }
};
  if (!eventDetails) {
    return null;
  }

  const renderValue = (value: any) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
  };
  const isFreeSlot = String(eventDetails.slotStatus || "").toLowerCase().includes("free");
  const slotStatus = String(eventDetails.slotStatus || "").toLowerCase();
  const showStudentContactDetails =
    slotStatus.includes("booked") ||
    slotStatus.includes("scheduled") ||
    slotStatus.includes("completed");

  const detailItems = [
    {
      label: "Slot Status",
      value: (
        <TeacherStatusBadge
          status={slotStatus}
          label={renderValue(eventDetails.slotStatus)}
          tones={{ free: 'success', booked: 'info' }}
        />
      ),
    },
    { label: "Course", value: renderValue(eventDetails.courseName) },
    { label: "Max No.slots", value: renderValue(eventDetails.maxNumberOfSlots) },
    { label: "Slots Booked", value: renderValue(eventDetails.slotsBooked) },
    { label: "International Slot", value: renderValue(eventDetails.isInternationalSlot) },
    { label: "Student Name", value: renderValue(eventDetails.studentName) },
    ...(showStudentContactDetails
      ? [
          { label: "Student Contact", value: renderValue(eventDetails.studentContact) },
          { label: "Student Email", value: renderValue(eventDetails.studentEmail) },
        ]
      : []),
    { label: "Teacher Join Time", value: renderValue(eventDetails.teacherJointime) },
    { label: "Student Join Time", value: renderValue(eventDetails.studentJoinTime) },
    { label: "Timing", value: `${renderValue(eventDetails.startTime)} - ${renderValue(eventDetails.endTime)}` },
    { label: "Date", value: renderValue(eventDetails.slotDate) },
    { label: "Teacher Name", value: renderValue(eventDetails.teacherName) },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Class Details</ModalHeader>
      <ModalBody>
        <DescriptionList items={detailItems} />
      </ModalBody>
      <ModalFooter>
       
        {isFreeSlot && (
          <Button variant="danger" onClick={handleDelete} disabled={isLoading}>
            {isLoading ? "Deleting..." : "Delete Free Slot"}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default EventModal;